import axios from "axios";
import moment from "moment";
import { DateFormat } from "../../../modules/constants";

import { getClaims } from "../../../modules/login";

import {
  blockUnblockUser,
  unlockUser,
} from "../../../modules/profileManagement";
import { UserStatus } from "../../library/AccountStatus/AccountStatus.constants";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const LOADING_PARTICIPANTS = "LOADING_PARTICIPANTS";
const SET_PARTICIPANTS = "SET_PARTICIPANTS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getParticipants = (state) => state?.participants;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;
const getLoading = (state) => state?.loading;

const canViewParticipantPage = (state) =>
  getClaims(state, "participant.canView");
const canCreateParticipant = (state) =>
  getClaims(state, "participant.canCreate");
const canEditParticipant = (state) => getClaims(state, "participant.canEdit");
const canViewParticipantTemporaryPassword = (state) =>
  getClaims(state, "participant.temporaryPassword.canCreate");
const canUnLockParticipant = (state) =>
  getClaims(state, "participant.canUnlock");
const canUnblockParticipant = (state) =>
  getClaims(state, "participant.canBlock");
const canChangeStudyStatus = (state) =>
  getClaims(state, "study.status.canChange");
const canViewStudyStatus = (state) =>
  getClaims(state, "study.status.history.canView");
const canViewPersonalData = (state) =>
  getClaims(state, "participant.personalData.canView");
const canGenerateReport = (state) =>
  getClaims(state, "participant.report.canGenerate");

// Default state
const initialState = {
  participants: [],
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "date",
    order: orderType.DESC,
    filter: UserStatus.ALL.id,
  },
};

export const participantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PARTICIPANTS:
      return {
        ...state,
        loading: true,
      };
    case SET_PARTICIPANTS:
      const { data } = action;
      return {
        ...state,
        participants: data.data,
        totalItems: data.records,
        searchedParams: action.searchedParams,
        loading: false,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchParticipants = (siteId, searchedParams, studyId) => (dispatch) => {
  const params = {
    ...searchedParams,
    siteId,
    studyId,
  };

  dispatch({
    type: LOADING_PARTICIPANTS,
  });

  return axios
    .get(`/api/participant/getBySite`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_PARTICIPANTS,
        data,
        searchedParams,
      });
    })
    .catch((e) => {
      // if statement to avoid to show an error when the request is canceled
      if (e?.message === "cancel") {
        return;
      }

      return Promise.reject(
        e.response?.data
          ? e.response.data
          : "There was an error while trying to fetch participants!"
      );
    });
};

const fetchEntriesData =
  (startDate, endDate, participantId = null) =>
  (dispatch, getState) => {
    const params = {
      StartDate: startDate,
      EndDate: endDate,
      limit: 9999,
    };

    if (participantId) {
      params.ParticipantId = participantId;
    }

    return axios
      .get(`/api/diet/userinfo/entries`, { params })
      .then(({ data: { entries } }) => {
        const reportData = {
          entries,
          generatedDate: moment().format(DateFormat.BASE_FORMAT),
        };
        return Promise.resolve(reportData);
      })
      .catch((e) => {
        return Promise.reject(
          e.response?.data
            ? e.response.data
            : `There was an error while trying to get your meal data. ${e}`
        );
      });
  };

export const mapStateToProps = (state) => {
  return {
    participants: getParticipants(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    loading: getLoading(state),
    canViewParticipantPage: canViewParticipantPage(state),
    canCreateParticipant: canCreateParticipant(state),
    canEditParticipant: canEditParticipant(state),
    canViewParticipantTemporaryPassword:
      canViewParticipantTemporaryPassword(state),
    canUnLockParticipant: canUnLockParticipant(state),
    canChangeStudyStatus: canChangeStudyStatus(state),
    canViewStudyStatus: canViewStudyStatus(state),
    canUnblockParticipant: canUnblockParticipant(state),
    canViewPersonalData: canViewPersonalData(state),
    canGenerateReport: canGenerateReport(state),
  };
};

export const mapDispatchToProps = {
  fetchParticipants,
  unlockUser,
  blockUnblockUser,
  resetState,
  fetchEntriesData,
};
